import { Component, inject } from '@angular/core';
import { NonNullableFormBuilder } from '@angular/forms';
import { StorageService } from '@app/core/service';
import { OpenClose, PopupBaseComponent } from '@app/shared/popup';

@Component({
    selector: 'app-logout',
    templateUrl: './logout.component.html',
    styleUrls: ['./logout.component.scss'],
    animations: [OpenClose],
    standalone: false
})
export class LogoutPopupComponent extends PopupBaseComponent<any> {
    private readonly storageService = inject(StorageService);
    private readonly fb = inject(NonNullableFormBuilder);
    readonly form = this.fb.group({
        notShowAgain: this.fb.control<boolean>(false),
    });

    closePopup(data: 'logout' | 'close'): void {
        if (data === 'logout') {
            this.save();
        }
        this.close(data);
    }

    private save(): void {
        this.storageService.write('logoutDoNotShowMessage', this.form.controls.notShowAgain.value);
    }
}
